import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SignInLayer from "../components/SignInLayer";
import { useAuth } from "../contexts/AuthContext";

const SignInPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const hasNavigatedRef = useRef(false);

  const handleAuthenticate = async (credentials) => {
    setError(''); // Limpar erro anterior
    console.log('🎯 SignInPage - handleAuthenticate chamado com:', { email: credentials.email, hasPassword: !!credentials.password });
    setLoading(true);
    try {
      console.log('🎯 SignInPage - Chamando função login...');
      const result = await login(credentials.email, credentials.password);
      console.log("✅ SignInPage - Login result:", result);
      // Garantir que token foi salvo
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      console.log('💾 SignInPage - Token no localStorage após login:', !!token, token ? '***TOKEN_OCULTO***' : 'null');

      // 🔐 Se requer 2FA, NÃO navega (modal abre e fica na tela de login)
      if (result?.requires2FA) {
        console.log('🔐 SignInPage - 2FA necessário, aguardando validação do código...');
        console.log('📧 SignInPage - Código enviado para:', result.email);
        return; // Não navega, fica na tela de login com modal aberto
      }

      if (result?.success && !hasNavigatedRef.current) {
        console.log('🎯 SignInPage - Login bem-sucedido, navegando baseado no role...');
        console.log('🔍 SignInPage - User data:', result.user);
        console.log('🔍 SignInPage - User role:', result.user?.role);
        hasNavigatedRef.current = true;
        const isAdmin = result.user?.role === "admin";
        const destination = isAdmin ? "/admin/dashboard" : "/dashboard";
        console.log(`➡️ SignInPage - Navegando para ${destination}`);
        navigate(destination, { replace: true });
      } else {
        console.log('⚠️ SignInPage - Navegação bloqueada:', { success: result?.success, hasNavigated: hasNavigatedRef.current });
      }
    } catch (error) {
      console.error("❌ SignInPage - Erro no login:", error);
      
      // Definir mensagem de erro amigável
      if (error.response?.status === 401 || error.response?.status === 400) {
        setError('Email ou senha incorretos. Verifique suas credenciais e tente novamente.');
      } else if (error.response?.status === 403) {
        setError('Acesso negado. Entre em contato com o suporte.');
      } else {
        setError('Erro ao fazer login. Tente novamente mais tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* SignInLayer */}
      <SignInLayer handleAuthenticate={handleAuthenticate} loading={loading} error={error} />
    </>
  );
};

export default SignInPage;
